<template>
  <div
    class="header-bar-wrapper"
    :style="'padding-left:' + headerBarOffset + 'px;padding-right:' + headerBarOffset + 'px;'"
  >
    <multibook-list @goTo="goTo" v-if="multibookListState && multiconfig"> </multibook-list>
    <div
      class="multibook-list-active"
      v-if="multibookListState && multiconfig"
      @click="multibookListState = !multibookListState"
    ></div>
    <div class="title-wrapper">
      <dir class="home-icon-wrapper" @click="homeScreen()" title="Strona główna" v-if="isWeb || multiconfig">
        <img :src="homeIcon" alt="Home" />
      </dir>
      <dir
        class="list-icon-wrapper"
        @click="multibookListState = !multibookListState"
        title="Menu wyboru"
        v-if="multiconfig"
      >
        <img :src="listIcon" alt="Home" />
      </dir>
      <div
        class="header-title"
        :class="[{ headerElementHide: galleryActive }, { headerElementHide: isModalImageActive }]"
      >
        <div id="multiBookTitle">
          <span class="multiBookTitleColor">{{ multibookHeader.main }}</span>
          {{ multibookHeader.second }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MultibookList from './MultibookList/MultibookList';
import { LAUNCHER_URL } from '__mainSrcDir/config';
let packageJSON = require('__rootDir/package.json');

export default {
  name: 'header-bar',
  props: [
    // "defaultPage"
  ],
  components: { MultibookList },
  data: function () {
    return {
      multibookHeader: {
        main: packageJSON.multibookHeader.main,
        second: packageJSON.multibookHeader.second,
        version: packageJSON.version,
      },
      multibookListState: false,
    };
  },
  methods: {
    openUrl(link) {
      if (!process.env.VUE_APP_IS_WEB) {
        this.$electron.shell.openExternal(link);
      } else {
        console.log('WEB openURL');
      }
    },
    homeScreen() {
      if (this.isWeb) {
        this.firstPage();
        window.location.replace(`${LAUNCHER_URL}`);
      } else {
        this.redirectMain();
      }
    },
    firstPage() {
      this.$emit('firstPage');
    },
    redirectDev(type) {
      this.$router.push(`/${type}`);
    },
    redirectPage(id) {
      this.$router.push(`/page/${id}`);
    },
    redirectGame(type) {
      this.$router.push(`/game/${type}`);
    },
    redirectMain() {
      // this.$router.push(`/page/-1`);
      this.firstPage();
      setTimeout(() => {
        this.$router.push('/');
      }, 1500);
    },
    goTo(id) {
      this.multibookListState = false;
      this.firstPage();
      setTimeout(() => {
        this.$store.commit('CHANGE_MULTIBOOK_TYPE', id);
        this.$router.push(`/${id}`);
      }, 1500);
    },
  },
  computed: {
    modalActive() {
      return this.$store.getters.modalActive;
    },
    isModalImageActive() {
      return this.$store.getters.isModalImageActive;
    },
    galleryActive() {
      return this.$store.getters.galleryActive;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    headerBarOffset() {
      return this.$store.getters.headerBarOffset;
    },
    isWeb() {
      // console.log('process.env.VUE_APP_IS_WEB', process.env.VUE_APP_IS_WEB);
      // console.log('process.env.IS_WEB', process.env.IS_WEB);
      return process.env.VUE_APP_IS_WEB === true;
    },
    multiconfig() {
      // console.log('process.env.VUE_APP_IS_WEB', process.env.VUE_APP_IS_WEB);
      // console.log('process.env.IS_WEB', process.env.IS_WEB);
      return this.$store.getters.multiconfigTest;
    },
    homeIcon() {
      return require(`__mainSrcDir/assets/icons/home-48px.svg`);
      // return require(`src/renderer/assets/icons/home-48px.svg`);
    },
    listIcon() {
      return require(`__mainSrcDir/assets/icons/list.svg`);
      // return require(`src/renderer/assets/icons/home-48px.svg`);
    },
  },
};
</script>
<style lang="scss">
@import '~@/assets/sass/variable';
.header-bar-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  .multibook-list-active {
    position: fixed;
    top: 0;
    left: 0;
    width: 1920px;
    z-index: 99998;
    background: transparent;
    height: 1080px;
  }
  .home-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    transition: all 0.4s ease;
    img:hover {
      cursor: pointer;
      background: url('~@/assets/icons/home-on48px.svg');
    }
  }
  .list-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    transition: all 0.4s ease;
  }
  .title-wrapper {
    display: flex;
    justify-content: center;
    align-self: center;
    .header-title {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 1rem;
    }
  }
  #multiBookTitle {
    font-size: larger;
    width: 35rem;
    text-align: left;
    .multiBookTitleColor {
      color: $multiBookTitleColor;
    }
  }
  .test-button {
    border: 1px solid $multiBookTitleColor;
    color: $multiBookTitleColor;
    transition: all 0.4s ease;
    padding: 3px;
  }
  .test-button:hover {
    border: 1px solid white;
    color: white;
    background-color: $multiBookTitleColor;
  }
}
.searchInputContainer {
  display: flex;
  width: 20vw;
  .searchButton {
    margin-left: 1vw;
  }
}
.headerElementHide {
  visibility: hidden !important;
}
</style>
